const updateItems = [
  {
    date: '08月01日',
    title: '暑期档热门电影专题上线',
    desc: '最新院线动作大片高清合集已整理上线，不卡顿秒播，即刻畅享',
    tag: '新上线',
  },
  {
    date: '07月30日',
    title: '追剧日历功能更新',
    desc: '热门电视剧每日更新进度一目了然，不再错过任何精彩剧集',
    tag: '功能',
  },
  {
    date: '07月28日',
    title: '经典电影修复版批量上线',
    desc: '数十部影史经典电影高清修复版已入库，重温银幕永恒记忆',
    tag: '上新',
  },
  {
    date: '07月25日',
    title: '移动端播放体验优化',
    desc: '手机和平板设备观影流畅度大幅提升，地铁追剧更丝滑',
    tag: '优化',
  },
  {
    date: '07月22日',
    title: '悬疑惊悚专题周开启',
    desc: '精选全球高分悬疑电影，深夜关灯沉浸式观影体验',
    tag: '专题',
  },
  {
    date: '07月19日',
    title: '片源库突破10万大关',
    desc: '夜猫电影院高清片源正式突破10万部，免费影院一网打尽',
    tag: '里程碑',
  },
  {
    date: '07月15日',
    title: '用户反馈通道上线',
    desc: '开放影片推荐与问题反馈入口，您的意见帮助我们做得更好',
    tag: '公告',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          夜猫电影院最新片源更新与平台动态
        </p>

        <div className="relative">
          <div className="absolute left-5 md:left-6 top-0 bottom-0 w-px bg-background-300/60"></div>

          <div className="space-y-8">
            {updateItems.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-5 pl-12 md:pl-14">
                <div className="absolute left-0 w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-50 border-2 border-primary-200 flex items-center justify-center flex-shrink-0 z-10">
                  <div className="w-3 h-3 rounded-full bg-primary-500"></div>
                </div>

                <div className="flex-1 bg-background-50 border border-background-200/60 rounded-xl p-5 transition-colors duration-200 hover:border-primary-200/50 cursor-pointer">
                  <div className="flex flex-wrap items-center gap-3 mb-2">
                    <span className="text-xs text-foreground-400 font-medium whitespace-nowrap">
                      {item.date}
                    </span>
                    <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}